import { BowArrow, Cross, type LucideIcon, Shield, Sword } from "lucide-react";
import type { RaidRole } from "./roles";

// Kept separate from roles.ts so the data module stays free of lucide (runtime UI) imports.
export const RAID_ROLE_ICONS: Record<RaidRole, LucideIcon> = {
  tank: Shield,
  healer: Cross,
  melee_dps: Sword,
  ranged_dps: BowArrow,
};
